module.exports = __webpack_public_path__ + "media/images/icon-value-proposition-2dfb9433780566f84056fbc8625ecd33.svg";